const normalized = (value) => String(value || "").trim().toLowerCase();

export const clientsForIssuer = (clients, issuerId) => clients.filter((client) => !client.issuerId || client.issuerId === issuerId);

export const normalizeLegacyClientScopes = (data) => {
  if (!data || !Array.isArray(data.clients) || !Array.isArray(data.businesses) || !data.businesses.length) return data;
  const fallbackIssuerId = data.businesses[0].id;
  const invoices = Array.isArray(data.invoices) ? data.invoices : [];
  const clients = data.clients.map((client) => {
    if (client.issuerId || client.sharedAcrossIssuers === true) return client;
    const linkedIssuerIds = [...new Set(invoices
      .filter((invoice) => invoice.clientId === client.id || (!invoice.clientId && invoice.client === client.name))
      .map((invoice) => invoice.issuerId)
      .filter(Boolean))];
    return {
      ...client,
      issuerId: linkedIssuerIds.length === 1 ? linkedIssuerIds[0] : fallbackIssuerId,
      sharedAcrossIssuers: false,
    };
  });
  return { ...data, clients };
};

export const clientScopeLabel = (client, businesses = []) => {
  if (!client?.issuerId) return "Available to every issuer";
  const issuer = businesses.find((business) => business.id === client.issuerId);
  return issuer ? `Only ${issuer.name}` : "Restricted to one issuer";
};

export const findClientConflict = (clients, candidate) => clients.find((client) => {
  if (client.id === candidate.id) return false;
  const sameIdentity = normalized(client.name) === normalized(candidate.name)
    || (candidate.email && normalized(client.email) === normalized(candidate.email));
  if (!sameIdentity) return false;
  return !client.issuerId || !candidate.issuerId || client.issuerId === candidate.issuerId;
});

export const resolveClient = (clients, { clientId, clientName, issuerId } = {}) => {
  const eligible = clientsForIssuer(clients, issuerId);
  return eligible.find((client) => client.id === clientId)
    || eligible.find((client) => client.name === clientName)
    || eligible[0]
    || null;
};
